export default "assets/images/map_terroir-7719b1cf.png";